"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const core_1 = require("@material-ui/core");
const themes_1 = require("../../../../../utils/themes");
const react_redux_1 = require("react-redux");
const api_1 = require("../../../../../utils/api");
const data_table_1 = tslib_1.__importDefault(require("../../../../../layouts/data-table"));
const js_cookie_1 = tslib_1.__importDefault(require("js-cookie"));
const Icons_1 = require("src/components/Icons");
function PreprocessingStep5AnomalyDetection(props) {
    const { setLagVariablesDataMain, isVisualizeTable, visualizationTable, lagVariablesCountError, lagVariablesColumnError } = props;
    const projectInfo = react_redux_1.useSelector((state) => state.ProjectInfo);
    const lagVariablesDataSaved = react_redux_1.useSelector((state) => state.lagVariables);
    const selectedColumns = react_redux_1.useSelector((state) => state.columnSelectionS22);
    const [lagVariablesData, setLagVariablesData] = react_1.useState({
        lagVariablesColumn: lagVariablesDataSaved && lagVariablesDataSaved.lagVariablesColumn || "",
        no_ofLagVariables: lagVariablesDataSaved && lagVariablesDataSaved.no_ofLagVariables || "12",
        retainLabels: lagVariablesDataSaved && lagVariablesDataSaved.retainLabels || "",
        availableLabels: [],
        availableColumns: [
            ...selectedColumns && selectedColumns.selectedCategoricalColumns,
            ...selectedColumns && selectedColumns.selectedNumericalColumns,
            ...selectedColumns && selectedColumns.selectedTargetColumn,
            ...selectedColumns && selectedColumns.selectedDateTime,
        ],
    });
    react_1.useEffect(() => {
        console.log("lagVariablesData", lagVariablesData);
        console.log("interpolationFrequency", lagVariablesDataSaved);
        setLagVariablesDataMain(lagVariablesData);
    }, [lagVariablesData, setLagVariablesDataMain]);
    react_1.useEffect(() => {
        let isMounted = true;
        const fetchUniqueLabels = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const projectDetails = {
                    projectname: projectInfo && projectInfo.projectname,
                    problemtype: projectInfo && projectInfo.problemtype,
                    version_name: projectInfo && projectInfo.version_name,
                    userid: js_cookie_1.default.get('USER_ID'),
                    label_column: "labels",
                };
                const uniqueLabelsRes = yield api_1.getUniqueLabels(projectDetails);
                if (isMounted) {
                    setLagVariablesData((prevData) => (Object.assign({}, prevData, { availableLabels: uniqueLabelsRes.data.unique_labels })));
                }
            }
            catch (error) {
                console.error("Error fetching unique labels:", error);
            }
        });
        fetchUniqueLabels();
        return () => {
            isMounted = false;
        };
    }, [projectInfo]);
    react_1.useEffect(() => {
        console.log(isVisualizeTable);
    }, [isVisualizeTable]);
    const handleDropdownChange = (e, field) => {
        setLagVariablesData((prev) => (Object.assign({}, prev, { [field]: e.target.value })));
    };
    return (react_1.default.createElement(core_1.Grid, { container: true }, isVisualizeTable ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 12, lg: 12 },
            visualizationTable && visualizationTable.length > 0 ? (react_1.default.createElement(data_table_1.default, { csvData: visualizationTable })) : (react_1.default.createElement(core_1.Typography, { variant: "body1" }, "No Data to Show...")),
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 12, style: {
                    backgroundColor: "rgba(42, 123, 236, 0.1)",
                    padding: "20px",
                    borderRadius: "5px",
                    marginTop: "30px"
                } },
                react_1.default.createElement(core_1.Typography, { variant: "h6", style: { color: "#005B96", fontWeight: "bold", display: 'flex', gap: '10px' } },
                    react_1.default.createElement(core_1.IconButton, { style: { padding: "0px" } },
                        react_1.default.createElement(Icons_1.Info, { stroke: "#005B96", width: '36', height: '36' })),
                    "Are you sure you want to continue?"),
                react_1.default.createElement(core_1.Typography, { variant: "body1", style: { color: "#005B96", paddingLeft: '46px' } }, "Before preceding to the next step, please ensure you have reviewed the above data carefully. Once you proceeded, you will not be able to make any changes."))))) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 2, lg: 2 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 8, lg: 8, style: themes_1.handlingMissingValDivAnomaly },
            react_1.default.createElement(core_1.Typography, { variant: "subtitle1" }, "Lag Variable Column"),
            react_1.default.createElement(core_1.TextField, { select: true, fullWidth: true, value: lagVariablesData.lagVariablesColumn, error: lagVariablesColumnError !== "", helperText: lagVariablesColumnError, style: { marginBottom: "15px" }, onChange: (e) => handleDropdownChange(e, "lagVariablesColumn") }, (lagVariablesData.availableColumns || []).map((column) => (react_1.default.createElement(core_1.MenuItem, { key: column, value: column }, column)))),
            react_1.default.createElement("br", null),
            react_1.default.createElement(core_1.Typography, { variant: "subtitle1" }, "Number of Lag Variables"),
            react_1.default.createElement(core_1.TextField, { fullWidth: true, type: "number", value: lagVariablesData.no_ofLagVariables, style: { marginBottom: "15px" }, error: lagVariablesCountError !== "", helperText: lagVariablesCountError, onChange: (e) => setLagVariablesData((prev) => (Object.assign({}, prev, { no_ofLagVariables: parseInt(e.target.value, 10) }))), inputProps: { min: 1 } }),
            react_1.default.createElement("br", null),
            react_1.default.createElement(core_1.Typography, { variant: "subtitle1" }, "Retain Label"),
            react_1.default.createElement(core_1.TextField, { select: true, fullWidth: true, value: lagVariablesData.retainLabels, style: { marginBottom: "15px" }, onChange: (e) => handleDropdownChange(e, "retainLabels") }, lagVariablesData.availableLabels.map((column) => (react_1.default.createElement(core_1.MenuItem, { key: column, value: column }, column))))),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 2, lg: 2 })))));
}
exports.PreprocessingStep5AnomalyDetection = PreprocessingStep5AnomalyDetection;
//# sourceMappingURL=pre-processing-step5-Anomaly.js.map